angular.module('dnecom').controller('CampaignController', ["$scope", "$http", "$window", "notifications", "wizardModal", function($scope, $http, $window, notifications, wizardModal) {
    $scope.defaultCampaign = TemplateData.value('defaultCampaign');
    $scope.customCampaigns = TemplateData.value('customCampaigns');
    sortCampaigns();
    $scope.emailTemplates = TemplateData.value('emailTemplates');
    $scope.store = TemplateData.value('store');

    function sortCampaigns() {
        $scope.customCampaigns = $scope.customCampaigns.sort(function(a, b) {
            if (a.priority === b.priority) {
                return a.id < b.id ? -1 : 1;
            }

            return a.priority < b.priority ? -1 : 1;
        });
    }

    $scope.toggleEnabled = function(campaign) {
        campaign.isEnabled = !campaign.isEnabled;
        $scope.updateCampaign(campaign);
    };

    $scope.updateCampaign = function(campaign) {
        return $http
            .put(Routing.generate('campaign_update', {
                store: campaign.store,
                campaign: campaign.id
            }), campaign)
            .then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message);
                    return;
                }

                $scope.currentCampaign = response.data.campaign;
                notifications.success('Campaign updated.');
            }, function() {
                notifications.danger('Request error.');
            });
    };

    $scope.createCampaign = function(campaign) {
        $http.post(
            Routing.generate('campaign_create', {
                store: campaign.store
            }),
            campaign
            ).then(function(response) {
            if (!response.data.success) {
                notifications.danger(response.data.message);
                return;
            }

            $scope.customCampaigns.push(response.data.campaign);
            sortCampaigns();
            notifications.success('Campaign created.');
        }, function() {
            notifications.danger('Request error.');
        });
    };

    $scope.deleteCampaign = function(index) {
        var campaign = $scope.customCampaigns[index];
        $http.delete(
            Routing.generate('campaign_delete', {
                store: campaign.store,
                campaign: campaign.id
            })
            ).then(function(response) {
            if (!response.data.success) {
                notifications.danger(response.data.message);
                return;
            }

            $scope.customCampaigns.splice(index, 1);
            notifications.success('Campaign deleted.');
        }, function() {
            notifications.danger('Request error.');
        });
    };

    $scope.createCustomCampaign = function() {
        var defaultTemplateId = $scope.emailTemplates.length > 0 ? $scope.emailTemplates[0].id : null;

        var campaign = {
            triggerCondition: {},
            name: null,
            description: null,
            store: $scope.store.id,
            campaignEmails: [
                {
                    timeout: {days: 0, hours: 0, minutes: 15},
                    emailTemplate: defaultTemplateId
                }
            ]
        };

        var campaignModal = wizardModal.open({
            templateUrl: 'campaignModal.html',
            controller: 'CampaignModalController',
            size: 'lg',
            resolve: {
                campaign: function() {
                    return campaign;
                }
            }
        });

        campaignModal.result.then(function(campaign) {
            $scope.createCampaign(campaign.campaign);
        });
    };

    $scope.editCustomCampaign = function(campaign, index) {
        $scope.currentCampaign = angular.copy(campaign);

        var campaignModal = wizardModal.open({
            templateUrl: 'campaignModal.html',
            controller: 'CampaignModalController',
            size: 'lg',
            resolve: {
                campaign: function() {
                    return $scope.currentCampaign;
                }
            }
        });

        campaignModal.result.then(function(campaign) {
            $scope.updateCampaign(campaign.campaign).then(function() {
                $scope.customCampaigns[index] = campaign.campaign;
            });
        });
    };

    $scope.move = function(index, direction) {
        var campaign = $scope.customCampaigns[index];

        $http.post(
            Routing.generate('campaign_move', {
                store: campaign.store,
                campaign: campaign.id,
                direction: direction
            })
        ).then(function(response) {
            if (!response.data.success) {
                notifications.danger(response.data.message || 'Invalid server response.');
                return;
            }

            $scope.customCampaigns[index] = response.data.campaign;

            for (var i = 0; i < $scope.customCampaigns.length; i++) {
                if ($scope.customCampaigns[i].id == response.data.campaign2.id) {
                    $scope.customCampaigns[i] = response.data.campaign2;
                    break;
                }
            }

            sortCampaigns();

            notifications.success('Campaign updated.');
        }, function() {
            notifications.danger('Request error.');
        });
    };

    $scope.statistics = function(index) {
        var campaign = $scope.customCampaigns[index];

        $window.location.href = Routing.generate('campaign_statistics', {
            store: campaign.store,
            campaign: campaign.id
        });
    };
}]);
